import { render } from "./ValueListView.vue?vue&type=template&id=7c825b14&scoped=true&ts=true"
import script from "./ValueListView.vue?vue&type=script&lang=ts"
export * from "./ValueListView.vue?vue&type=script&lang=ts"

import "./ValueListView.vue?vue&type=style&index=0&id=7c825b14&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c825b14"]])

export default __exports__